import React, { Component } from 'react';
import { connect } from 'react-redux';

import imageAirBank from '../images/payment-methods/airbank@2x.png';
import imageApplePay from '../images/payment-methods/applepay@2x.png';
import imageBankAccount from '../images/payment-methods/bank_account@2x.png';
import imageBitcoin from '../images/payment-methods/bitcoin@2x.png';
import imageCeskaSporitelna from '../images/payment-methods/csas@2x.png';
import imageClickToPay from '../images/payment-methods/clicktopay@2x.png';
import imageCofidis from '../images/payment-methods/cofidis@2x.png';
import imageCsob from '../images/payment-methods/csob@2x.png';
import imageFio from '../images/payment-methods/fio@2x.png';
import imageKomercniBanka from '../images/payment-methods/kb@2x.png';
import imageGooglePay from '../images/payment-methods/googlepay@2x.png';
import imageGopay from '../images/payment-methods/gopay@2x.png';
import imageMBank from '../images/payment-methods/mbank@2x.png';
import imageMPayment from '../images/payment-methods/mpayment@2x.png';
import imageMoneta from '../images/payment-methods/moneta@2x.png';
import imagePartners from '../images/payment-methods/partners@2x.png';
import imagePaymentCard from '../images/payment-methods/payment_card@2x.png';
import imagePaySafeCard from '../images/payment-methods/paysafecard@2x.png';
import imagePlatimPak from '../images/payment-methods/platimpak@2x.png';
import imagePrsms from '../images/payment-methods/prsms@2x.png';
import imageRaiffeisen from '../images/payment-methods/raiffeisen@2x.png';
import imageSlovenskaSporitelna from '../images/payment-methods/slsp@2x.png';
import imageSupercash from '../images/payment-methods/supercash@2x.png';
import imageSkipPay from '../images/payment-methods/skippay@2.png';
import imageVub from '../images/payment-methods/vub@2x.png';
import imageTatraBanka from '../images/payment-methods/tatrabanka@2x.png';
import imageTwisto from '../images/payment-methods/twisto@2x.png';

class PaymentMethodInput extends Component {

	state = {
		imageWidth: 0,
		imageHeight: 0,
	};

	images = {
		BANK_ACCOUNT: imageBankAccount,
		BITCOIN: imageBitcoin,
		CLICK_TO_PAY: imageClickToPay,
		GOPAY: imageGopay,
		GPAY: imageGooglePay,
		MPAYMENT: imageMPayment,
		PAYMENT_CARD: imagePaymentCard,
		PAYSAFECARD: imagePaySafeCard,
		PRSMS: imagePrsms,
		SUPERCASH: imageSupercash,
		TWISTO: imageTwisto,
		SKIPPAY: imageSkipPay,

		// COMGATE
		APPLEPAY_REDIRECT: imageApplePay,
		BANK_CZ_AB_PSD2: imageAirBank,
		BANK_CZ_CS_PSD2: imageCeskaSporitelna,
		BANK_CZ_CSOB_PSD2: imageCsob,
		BANK_CZ_FB_PSD2: imageFio,
		BANK_CZ_KB_PSD2: imageKomercniBanka,
		BANK_CZ_MB_PSD2: imageMBank,
		BANK_CZ_MO_PSD2: imageMoneta,
		BANK_CZ_OTHER: imageBankAccount,
		BANK_CZ_PB_PSD2: imagePartners,
		BANK_CZ_RB_PSD2: imageRaiffeisen,
		BANK_SK_OTHER: imageBankAccount,
		BANK_SK_SLSP: imageSlovenskaSporitelna,
		BANK_SK_TB_P: imageTatraBanka,
		BANK_SK_VUB_P: imageVub,
		CARD_CZ_COMGATE: imagePaymentCard,
		GOOGLEPAY_REDIRECT: imageGooglePay,
		LATER_PLATIMPAK: imagePlatimPak,
		LATER_TWISTO: imageTwisto,
		LOAN_COFIDIS: imageCofidis,
		PART_TWISTO: imageTwisto,
	};

	onChange = (e) => {
		this.props.input.onChange(e.target.value);
	};

	handleImageSize = (el) => {
		const self = this;

		if (!el) return;

		el.onload = function() {
			self.setState({
				imageWidth: this.naturalWidth,
				imageHeight: this.naturalHeight,
			});
		}
	};

	render() {
		const { instrument, lang } = this.props;

		const attributes = {
			id: `${this.props.input.name}-${instrument.paymentInstrument}`,
			name: this.props.input.name,
			type: 'radio',
			value: instrument.paymentInstrument,
			onChange: this.onChange,
			checked: this.props.checked || false,
		};

		let label = instrument.label[lang] || instrument.label['cs'];

		if (label === 'Bankovní převod') {
			label = 'On-line bankovní převod';
		}

		return (
			<div className="payment-method-input">
				<input {...attributes} />
				<label htmlFor={attributes.id}>
					{!!this.images[instrument.paymentInstrument] &&
						<span className="payment-method-input__img-container">
							<img
								src={this.images[instrument.paymentInstrument]}
								alt={label}
								className="payment-method-input__img"
								ref={el => this.handleImageSize(el) }
								width={this.state.imageWidth / 2}
								height={this.state.imageHeight / 2}
							/>
						</span>
					}
					<span className="payment-method-input__label">{label}</span>
				</label>
			</div>
		);
	}
}

export default connect(state => ({
	lang: state.app.lang,
}))(PaymentMethodInput);



// WEBPACK FOOTER //
// ./src/components/PaymentMethodInput.jsx